<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
            <v-layout row>
            <v-flex xs12 sm2>
              <v-autocomplete
                v-model="selectedStore"
                :items="storeNames"
                item-text="name"
                label="Store"
                @change="getDataFromApi"
                class="text-truncate"
              ></v-autocomplete>
            </v-flex>

            <v-spacer> </v-spacer>
            <v-flex xs12 sm2>
              <v-menu
                ref="startDateMenu"
                :close-on-content-click="false"
                v-model="startDateMenu"
                :nudge-right="40"
                :return-value.sync="startDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="startDate"
                  label="Start Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="startDate" @input="$refs.startDateMenu.save(startDate)">
                </v-date-picker>

              </v-menu>
            </v-flex>

            <v-flex xs12 sm2>
              <v-menu
                ref="endDateMenu"
                :close-on-content-click="false"
                v-model="endDateMenu"
                :nudge-right="40"
                :return-value.sync="endDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="endDate"
                  label="End Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="endDate" @input="$refs.endDateMenu.save(endDate)">
                </v-date-picker>

              </v-menu>
            </v-flex>


            <v-flex xs12 sm1 mr-3 pt-2>
              <v-btn color="primary" small @click="getDataFromApi">VIEW</v-btn>
            </v-flex>
          </v-layout>

            <v-flex xs12 sm12 lg12>
              <v-data-table
                :headers="headers"
                :items="results"
                :pagination.sync="pagination"
                :total-items="totalResults"
                :loading="loading"
                class="elevation-1"
              >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="body-2 font-weight-regular accent--text"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.transactionDate }}</td>
                <td>{{ props.item.transactionId }}</td>
                <td>{{ props.item.payerReference }}</td>
                <td>{{ props.item.merchantId }}</td>
                <td>{{ props.item.transactionNarration }}</td>
                <td>{{ props.item.amount }}</td>
              </template>
              <template slot="no-data">
                <p> No data Found </p>
                <v-btn color="primary" @click="getDataFromApi" round>Reload</v-btn>
              </template>
             </v-data-table>
            </v-flex>
            <v-flex mt-2>
              <v-card-actions>
                <v-dialog
                    v-model="dialog"
                    width="500"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="secondary"
                        dark
                        v-on="on"
                      >
                        Export
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >
                        Download
                      </v-card-title>

                      <v-card-text>
                        <v-flex xs6>
                          <v-autocomplete
                            v-model="selectedStore"
                            :items="storeNames"
                            item-text="name"
                            label="Store"
                            @change="getDataFromApi"
                            class="text-truncate"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-menu
                            ref="exportStartDateMenu"
                            :close-on-content-click="false"
                            v-model="exportStartDateMenu"
                            :nudge-right="40"
                            :return-value.sync="exportStartDate"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="exportStartDate"
                              label="Start Date"
                              prepend-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker v-model="exportStartDate" @input="$refs.exportStartDateMenu.save(exportStartDate)">
                            </v-date-picker>

                          </v-menu>
                          <v-menu
                            ref="exportEndDateMenu"
                            :close-on-content-click="false"
                            v-model="exportEndDateMenu"
                            :nudge-right="40"
                            :return-value.sync="exportEndDate"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="exportEndDate"
                              label="End Date"
                              prepend-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker v-model="exportEndDate" @input="$refs.exportEndDateMenu.save(exportEndDate)">
                            </v-date-picker>

                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            :items="supportedExportTypes"
                            label="Export Type"
                            v-model="exportType"
                          ></v-select>
                        </v-flex>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="exportTransactions"
                        >
                          Download
                          <v-icon right dark>get_app</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              </v-card-actions>
            </v-flex>
          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewprocessingresults',
  data: function() {
    return {
      headers: [
        { text: 'Transaction Date', value: 'transactionDate' },
        { text: 'Mpesa Ref', value: 'transactionId' },
        { text: 'Payer Ref No', value: 'payerReference' },
        { text: 'Merchant Id', value: 'merchantId' },
        { text: 'Description', value: 'transactionNarration' },
        { text: 'Amount', value: 'amount' }
      ],
      results: [],
      message: '',
      error: '',
      loading: false,
      pagination: {sortBy: 'transactionDate', descending: true},
      totalResults: 0,
      stores: [],
      selectedStore: '',
      storeNames: [],
      startDate: null,
      endDate: null,
      supportedExportTypes: ['EXCEL'],
      exportType: 'EXCEL',
      startDateMenu: false,
      endDateMenu: false,
      exportStartDateMenu: false,
      exportEndDateMenu: false,
      exportStartDate: this.startDate,
      exportEndDate: this.endDate,
      dialog: false
    }
  },
  watch: {
    pagination: {
      handler () {
      },
      deep: true
    },
    startDate: {
      handler () {
        if (this.startDate !== null) {
        }
      }
    }
  },
  mounted () {
    this.stores = store.state.user.mpesaStores
    if (this.stores.length > 0) {
      const mapFunction = p => p.name
      this.storeNames = this.stores.map(mapFunction)
      if (this.stores.length > 1) {
        this.storeNames.unshift('ALL')
      }
      this.selectedStore = this.storeNames[0]
    }
    this.getDataFromApi()
      .then(data => {
      })
    console.log(this.selectedStore)
  },
  methods: {
    exportTransactions () {
      let token = store.state.token

      var storeNameFilter = 'storeName=' + this.selectedStore
      let url = config.serverURI + '/transactions/export/mpesa?' + storeNameFilter + '&reportType=' + this.exportType + '&startDate=' + this.exportStartDate + '&endDate=' + this.exportEndDate
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Authorization': token
        },
        responseType: 'blob'
      }).then((response) => {
        var url = ''
        url = window.URL.createObjectURL(new Blob([response.data], {type: 'text/csv'}))
        if (this.exportType === 'PDF') {
          url = window.URL.createObjectURL(new Blob([response.data]))
        }
        const link = document.createElement('a')
        link.href = url
        const now = new Date()
        if (this.exportType === 'EXCEL') {
          this.exportType = 'csv'
        }
        const fileName = 'transactions_' + now + '.' + this.exportType
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        this.dialog = false
      }).catch(error => {
        console.log('error', error.response)
        var data = error.response.data
        if (data.message === 'Unauthorized' || error.response.status === 401) {
          console.log('redirecting')
          window.location = '/login'
        } else {
          this.error = data.message
        }
      })
    },
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getTransactions()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    getTransactions () {
      // reset transaction object and count
      this.results = []
      this.totalResults = 0
      var storeNameFilter = 'storeName=' + this.selectedStore
      var dateFilter = '&startDate=' + this.startDate + '&endDate=' + this.endDate
      var url = config.serverURI + '/transactions/get/mpesa?' + storeNameFilter + dateFilter
      console.log(url)
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              return
            }
            this.results = response.data
            this.totalResults = this.results.total
          })
          .catch(error => {
            var data = error.response.data
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.results
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// mpesatransactions.vue?1c243e8d